import routes from '@/modules/responsibilities/responsibilities-routes';
import store from '@/modules/responsibilities/responsibilities-store';

export default {
    routes,
    store,
}
